import { Button, Col, Row, Table } from "react-bootstrap"

const AddOrNoMask = ({setStep, data}) => {

    return (
        <>
            <p className="text-muted" hidden={data.anlagen.length > 0}>
                Geben Sie hier die Energieanlagen der neuen Liegenschaft ein.
            </p>
            <Row>
                <Col className="text-center mb-3">
                    <Button onClick={() => setStep("address")} variant="energo">
                        {data.anlagen.length > 0 ?
                            "Weitere Anlagen hinzufügen" :
                            "Anlagen im Gebäude hinzufügen"
                        }
                    </Button>
                </Col>
            </Row>
        </>
    )
}
export default AddOrNoMask;